// ─── API layer for Reminder Rules ────────────────────────────────────────────
// All endpoint knowledge for this feature lives here; components call these
// named functions and never assemble URLs. apiCall injects auth and returns
// { isSuccess, data, message }.
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";

const RULES = `${config.POSTLOGIN_API_URL_COMPANY}reminders/rules`;
const TEMPLATES = `${config.POSTLOGIN_API_URL_COMPANY}reminders/templates`;

/**
 * Lists the company's reminder rules.
 * @returns {Promise<object>} apiCall result whose data is the rules array.
 */
export const listReminderRules = () => apiCall(`${RULES}`, {}, {}, "GET");

/**
 * Creates a reminder rule.
 * @param {object} payload the rule payload.
 * @returns {Promise<object>} apiCall result whose data is the created rule.
 */
export const createReminderRule = (payload) =>
  apiCall(`${RULES}`, {}, payload, "POST");

/**
 * Updates a reminder rule (e.g. enable/disable).
 * @param {number} id the rule id.
 * @param {object} patch the fields to change.
 * @returns {Promise<object>} apiCall result whose data is the updated rule.
 */
export const updateReminderRule = (id, patch) =>
  apiCall(`${RULES}/${id}`, {}, patch, "PUT");

/**
 * Deletes a reminder rule.
 * @param {number} id the rule id.
 * @returns {Promise<object>} apiCall result.
 */
export const deleteReminderRule = (id) =>
  apiCall(`${RULES}/${id}`, {}, {}, "DELETE");

/**
 * Renders a reminder template as its recipient will receive it.
 * @param {object} payload `{ templateKey, reminderRuleId? }`.
 * @returns {Promise<object>} apiCall result whose data is the rendered preview.
 */
export const previewTemplate = (payload) =>
  apiCall(`${TEMPLATES}/preview`, {}, payload, "POST", true, false);
